import FetchUtils, { AbortableRequest } from '@dr-pam/common-components/Utils/FetchUtils';
import { useMemo } from 'react';
import { SearchRequest } from '../app/find-an-ndc-practitioner/search/route';
import { PublicProfile } from '../components/map/Practitioner';

export default class FindPractitionerService {
	public search(query: SearchRequest): AbortableRequest<PublicProfile[]> {
		const request = FetchUtils.postJson<PublicProfile[], SearchRequest>('/find-an-ndc-practitioner/search', query);
		return FetchUtils.abortableRequest(request);
	}
}

export function useFindPractitionerService() {
	const findPractitionerService = useMemo(() => new FindPractitionerService(), []);
	return findPractitionerService;
}
